<span v-if="statusShowProzente" v-safe-html="percent"></span>